import React from 'react'
import PropTypes from 'prop-types'
import { useFormTextArea } from './FormTextArea.logic'
import { FormTextAreaView } from './FormTextArea.view'

/**
 * FormTextArea Container Component
 * Multi-line text input field integrated with React Hook Form
 *
 * @example
 * <FormTextArea
 *   name="specialInstructions"
 *   control={control}
 *   label="Special Instructions"
 *   placeholder="Enter any special instructions..."
 *   rows={5}
 *   maxLength={500}
 * />
 */
export function FormTextArea({
  name,
  control,
  defaultValue,
  rules,
  label,
  placeholder,
  required,
  disabled,
  rows,
  maxLength,
  fluid,
  'data-testid': dataTestId,
  'data-automation-id': dataAutomationId,
}) {
  const {
    value,
    onChange,
    onBlur,
    name: fieldName,
    ref,
    error,
    errorMessage,
  } = useFormTextArea({ name, control, defaultValue, rules })

  return (
    <FormTextAreaView
      name={fieldName}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      textAreaRef={ref}
      label={label}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      rows={rows}
      maxLength={maxLength}
      fluid={fluid}
      error={error}
      errorMessage={errorMessage}
      data-testid={dataTestId}
      data-automation-id={dataAutomationId}
    />
  )
}

FormTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  defaultValue: PropTypes.string,
  rules: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  fluid: PropTypes.bool,
  'data-testid': PropTypes.string,
  'data-automation-id': PropTypes.string,
}

FormTextArea.defaultProps = {
  fluid: true,
  disabled: false,
  required: false,
  rows: 3,
  defaultValue: '',
}
